export default {"src":"/_next/static/media/my.7c264f31.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};